import React from 'react';

const TransformationsIcon = () => {
  return (
    <svg className="processing-diagram" viewBox="0 0 300 200" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="earth-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#425b76" />
          <stop offset="100%" stopColor="#2d3e50" />
        </linearGradient>
      </defs>
      
      {/* Earth/Globe */}
      <circle cx="85" cy="100" r="60" fill="url(#earth-gradient)" opacity="0.8" />
      <ellipse cx="85" cy="100" rx="60" ry="20" fill="none" stroke="#a0b4c8" strokeWidth="1" />
      <ellipse cx="85" cy="100" rx="40" ry="15" fill="none" stroke="#a0b4c8" strokeWidth="1" />
      <ellipse cx="85" cy="100" rx="20" ry="10" fill="none" stroke="#a0b4c8" strokeWidth="1" />
      <line x1="25" y1="100" x2="145" y2="100" stroke="#a0b4c8" strokeWidth="1" />
      <line x1="85" y1="40" x2="85" y2="160" stroke="#a0b4c8" strokeWidth="1" />
      
      {/* Transformation Arrow */}
      <path d="M155,100 L175,100 L175,80 L195,105 L175,130 L175,110 L155,110 Z" fill="url(#earth-gradient)" />
      
      {/* Grid Projection */}
      <rect x="205" y="45" width="80" height="110" fill="none" stroke="#a0b4c8" strokeWidth="1" />
      <line x1="225" y1="45" x2="225" y2="155" stroke="#a0b4c8" strokeWidth="1" />
      <line x1="245" y1="45" x2="245" y2="155" stroke="#a0b4c8" strokeWidth="1" />
      <line x1="265" y1="45" x2="265" y2="155" stroke="#a0b4c8" strokeWidth="1" />
      <line x1="205" y1="65" x2="285" y2="65" stroke="#a0b4c8" strokeWidth="1" />
      <line x1="205" y1="85" x2="285" y2="85" stroke="#a0b4c8" strokeWidth="1" />
      <line x1="205" y1="105" x2="285" y2="105" stroke="#a0b4c8" strokeWidth="1" />
      <line x1="205" y1="125" x2="285" y2="125" stroke="#a0b4c8" strokeWidth="1" />
      <line x1="205" y1="145" x2="285" y2="145" stroke="#a0b4c8" strokeWidth="1" />
    </svg>
  );
};

export default TransformationsIcon;